import BaseEntity from './BaseEntity'

const Props = {
  email: undefined,
  createdTime: undefined,
}

class Account extends BaseEntity {}

export default function createAccount(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Account(attr))
}
